export class GoodsModel {
  constructor(
    public id = 0,
    public goodsName = '',
    public standardName = '',
    public janCode = '',
    public buyerName = '',
    public pCode = '',
    public itemCode = ''
  ) { }
}